import moment from "moment";
import React, { Component } from "react";
import { translate } from "react-i18next";
import swal from 'sweetalert';
import Notifications, {notify} from 'react-notify-toast';

import BreadcrumbTitle from "../../../components/BreadcrumbTitle";
import InputForm from "../../../components/InputForm";
import LabelForm from "../../../components/LabelForm";
import SelectForm from "../../../components/SelectForm";
import AutocompleteForm from "../../../components/AutocompleteForm";
import ButtonForm from "../../../components/ButtonForm";

import AvatarInfo from "./AvatarInfo";
import PersonData from "./PersonData";
import SectionsForm from "./SectionsForm";
import StatusBar from "./StatusBar";

import { clinicHistory, clinicHistoryValuesOffer, clinicHistoryValuesOfferCell, colorClinicHistory, 
    donorHcData, formularioRender, functionalCriterial, getDateHour, rejectReasons 
} from "../../../libs/services";
import { isValidForm } from "../../../libs/functions";
import BiometricsData from "../BiometricsData";
import VitalSignsData from "../VitalSignsData";
import $ from 'jquery';
import Toolbar from "../toolbar/Register";


class ClinicHistoryForm extends Component{
    constructor(props){
        super(props);

        this.updateForm = this.updateForm.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.openModalHistorico = this.openModalHistorico.bind(this);
        this.onAutocompleteChange = this.onAutocompleteChange.bind(this);
        this.getAnswers = this.getAnswers.bind(this);
        this.onSave = this.onSave.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.verifyDonorDays = this.verifyDonorDays.bind(this);
        this.saving = this.saving.bind(this);
        this.verifyRangesBioSV = this.verifyRangesBioSV.bind(this);

        this.state = {
            person:{
                id:'',
                fullName:'',
                address:'',
                birthday:'',
                age:'',
                sex:'',
                civilStatus:'',
                jobProfile:'',
                phones:'',
                grouo_rh:'',
                photo:''
            },
            showPatient:false,
            patient:{
                names:'',
                lastnames:'',
                relationship:'',
                healthFacility:''
            },
            sections:[],
            form_id:'',
            donor_id:'',
            last_donation_date:"",
            last_donation_time:"",
            donation_type:'',
            extraction_type:'',
            donor_number:'',
            multigesta:"",
            donor_signature : "",
            colorBtnHistory:'',
            colorStatusBar:'',
            exist_extraction:false,
            observations:'',
            notes:'',
            staff_date:'',
            disable_obs:false,
            valoration:'',
            don_abr_rech:{},
            rejection_reasons:[],
            rejection_reasons_id:'',
            index_reject:-1,
            donation_status:'',
            rejection_type:'',
            rejection_days:'',
            DON_EDIT_REJECT_DAYS:false,
            date:'',
            today:'',
            clinic_history_id:'',
            saved:false,
            concent_key:''
        }
    }

    async componentDidMount(){
        var id = this.props.match.params.id;
        var type = this.props.match.params.type;
        var hf_id = sessionStorage.getItem("health_facilities_id");
        var et_id = 0;

        this.props.waiting.handleShow('Cargando...');

        var response = await functionalCriterial('don_abr_rech');
		if(response !== undefined){
			this.setState({
				don_abr_rech: response
			});
		}

        response = await getDateHour();
		if(response !== undefined){
			var aux = response.split('|');
			this.setState({
				today:aux[0]
			});
		}

        response = await rejectReasons('actives');
		if(response !== undefined){
            response.forEach((res)=>{
                res.values = res.name
            });
			this.setState({rejection_reasons:response});
		}	

        response = await colorClinicHistory('status_bar', id, type);
		if(response !== undefined){
			this.setState({
	    		colorStatusBar:response.color, 
                exist_extraction:response.exist_extraction
	    	});
		}

        response = await colorClinicHistory('button_history', id, type);
		if(response !== undefined){
			this.setState({colorBtnHistory:response.color});
		}


        response = await donorHcData(id, type, this.props.waiting);
        if(response){
            var phones = '';
            response.phones.forEach((phone, i)=>{
                phones += phone.type+': '+phone.number+(response.phones.length - 1 === i ? '' : ', ')
            })
            var person = {
                id:response.id,
                fullName:response.lastnames+' '+response.names,
                address:response.address,
                birthday:moment(response.birthday).format('DD/MM/YYYY'),
                age:response.age,
                sex:response.sex,
                civilStatus:response.civil_status !== null ? response.civil_status : '',
                jobProfile:response.job_profile,    
                phones:phones,
                grouo_rh:response.grouo_rh,
                photo: response.photo !== null ? response.photo : ''
            };
            var patient = {               
                name:response.patient_names,
                lastnames:response.patient_lastnames,
                relationship:response.relationship !== null ? response.relationship : '',
                healthFacility:response.patient_center
            };
            
            et_id = response.extraction_type_id;

            this.setState({
                patient:patient,
                person:person,
                showPatient:response.names !== "",
                donor_id:response.donor_id,
                donation_type:response.donation_type,
                extraction_type:response.extraction_type !== null ? response.extraction_type : '',
                donor_number:response.donor_number,
                concent_key: response.extraction_type === 'MÉDULA ÓSEA' ? 'INFORMED_CONSENT_MED' :
                                    response.extraction_type === 'SANGRE PERIFÉRICA' ? 'INFORMED_CONSENT_SP' :
                                    response.extraction_type === 'SANGRE PLACENTARIA' ? 'INFORMED_CONSENT_SPL' : ''
            });
        }

        await this.biometrics_data.getBiometrics(person.sex);
        await this.vital_signs_data.getVitalSigns(person.sex);

        if(type === 'CELLS'){
            response = await formularioRender(hf_id, person.sex, true, et_id);
            if(response){
                this.setState({sections:response.sections, form_id: response.id});
            }

            response = await clinicHistoryValuesOfferCell(id, this.props.waiting);
            if(response){
                this.setState({
                    staff_date: '** '+response.medical_staff+'\t'+
                                    (response.status !== null ? 
                                        moment(response.status.timestamp_date).format('DD/MM/YYYY')+' '+
								        moment(response.status.timestamp_time, 'HH:mm:ss').format('HH:mm')    
                                    :
                                        response.date
                                    ),
                    update: response.general !== null ? true : false,
                });
                
                    
                if(response.general !== null){
                    this.setState({
                        clinic_history_id: response.general.id,
                        multigesta: response.general.multigesta,
                        donor_signature: response.general.donor_signature,
                        observations: response.general.observations,
                        last_donation_date: response.general.last_donation_date !== null ? moment(response.general.last_donation_date).format('YYYY-MM-DD') : '',
                        last_donation_time: response.general.last_donation_time,
                        rejection_description: response.general.rejection_description,                        
                        disable_obs: response.general.observations !== "" ? true : false 
                    });

                    if(response.general.rejection_reasons_id !== null){
                        var index = this.state.rejection_reasons.findIndex(item => item.id === response.general.rejection_reasons_id);
                        var values = [this.state.rejection_reasons[index]];
                        this.onAutocompleteChange(values);
                    }
                }

                if(response.answers !== null){
                    var sections = this.state.sections;
                    sections.forEach((cat, i)=>{
                        cat.fields.forEach((field, j)=>{
                            var index = response.answers.findIndex(item => item.IdCampo === field.field_id);
    
                            if(index !== -1){
                                field.default_value = response.answers[index].Valor;
                            }
                        });
                    });
    
                    this.setState({sections:sections});
                }

                if(response.status != null){
                    this.setState({
                        valoration: response.status.status === 'DIFERIDO' || response.status.status === 'REJECT' ? 'NO_APTO' : response.status.status
                    });

                    if(response.status.status !== 'ACCEPT'){
                        var new_date = moment(response.status.timestamp_date).add('days', parseInt(response.general.rejections_days));

                        this.setState({ 
                            date:new_date.format('YYYY-MM-DD'),                            
                            rejection_reasons_id:response.general.rejection_reasons_id,
                            rejection_days:parseFloat(response.general.rejections_days),
                            donation_status: response.general.rejections_days === 0 || response.general.rejections_days === null ?
                                                'REJECT'
                                            : response.general.rejections_days > 0 ? 'DIFERIDO' : null,
                        });				
                    }
                }
            }

            
        }

        if(type === 'OFFER'){
            response = await clinicHistoryValuesOffer(id);
        }
    }

    handleChange(e){
        this.setState({[e.target.name]: e.target.value});

        if(e.target.name === 'valoration'){
            if(e.target.value === 'NO_APTO'){
                //this.rejectReasons('actives');
            }else{
                this.setState({donation_status: e.target.value});
            }
        }
    }

    updateForm(e, i, j){
		var sections = this.state.sections;
		
		sections[i].fields[j].default_value = e.target.value;

		this.setState({sections: sections});
	}

    openModalHistorico(){

    }

    onAutocompleteChange(values){
        if(values.length > 0){
            var value = values[0];

            var index = this.state.rejection_reasons.findIndex(obj => obj.id === value.id);
            if(index !== -1){
                var days = Math.round(value.rejection_days);
                var new_date = this.addDays(new Date(),days);

                this.setState({
                    index_reject:index,
                    donation_status: value.rejection_days === 0 || value.rejection_days === null ? 'REJECT' 
        				                : value.rejection_days > 0 ? 'DIFERIDO' : null,
                    rejection_reasons_id:value.id,
                    rejection_days:value.rejection_days,
                    rejection_description:value.name,
                    date:new_date.getFullYear()+'-'+("0" + (new_date.getMonth() + 1)).slice(-2)+'-'+("0" + new_date.getDate()).slice(-2)
                });
            }
        }
    }

    addDays(date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }

    onSave(){
        var id = this.props.match.params.id;
        var type = this.props.match.params.type;
        var error = '';

        if(!isValidForm('div.form-hc')){
            error = 'Campos Incompletos';
        }

        if(this.state.rejection_days < 0){
            error = 'No se permiten periodos de rechazo negativos';
            return;
        }

        if(error === ''){
            var biometrics = [];
            
            this.biometrics_data.state.biometrics.forEach((bio)=>{
                if(bio.show_in_ch){
                    var item = {
                        biometrics_id: bio.id,
                        value:bio.value
                    };
    
                    if(type === 'CELLS'){
                        item.offering_cell_id = id;
                    }
    
                    if(item.value !== ""){
                        biometrics.push(item);
                    }
                }                
            });

            var vital_signs = [];
            
            this.vital_signs_data.state.vital_signs.forEach((vs)=>{
                if(vs.show_in_ch){
                    var item = {
                        biometrics_id: vs.id,
                        value:vs.value
                    };
    
                    if(type === 'CELLS'){
                        item.offering_cell_id = id;
                    }
    
                    if(item.value !== ""){
                        vital_signs.push(item);
                    }
                }                
            });

            var obj = {
                vital_signs: {
                    list_data: vital_signs,
                    type: "BIO_F_SIGNOS",
                },
                biometrics: {
                    list_data: biometrics,
                    type: "BIO_F_BIO",
                },                
                ValoresDeHistoriaClinica: this.getAnswers(),
                donor_id: this.state.donor_id,
                form_id: this.state.form_id,
                donation_status:{
                    status: this.state.valoration //this.state.valoration !== 'NOT_RESULTS' ? this.state.donation_status : this.state.valoration
                },
                observations: this.state.observations,
                last_donation_date:  this.state.last_donation_date !== "" && this.state.last_donation_date !== null? 
											moment(this.state.last_donation_date).format('MM-DD-YYYY') 
									  : "",			
			    last_donation_time: this.state.last_donation_time,
                multigesta:this.state.multigesta !== "" ? this.state.multigesta : null,
                donor_signature: this.state.donor_signature,
            };

            if(type === 'CELLS'){
                obj = {
                    ...obj, 
                    vital_signs:{...obj.vital_signs, offering_cell_id:id},
                    biometrics:{...obj.biometrics, offering_cell_id:id},
                    offering_cell_id:id,
                    donation_status:{...obj.donation_status, offering_cell_id:id}
                };
            }

            if(this.state.donation_status === "REJECT" || this.state.donation_status === "DIFERIDO"){//Si el estatus es rechazado
				if(this.state.rejection_days !== "" && this.state.rejection_days !== undefined){
					obj.rejections_days = this.state.rejection_days;
				}else{
					obj.rejections_days = null;
				}

				obj.rejection_reasons_id = parseInt(this.state.rejection_reasons_id,10);
				obj.rejection_description = this.state.rejection_description;
                
			}else{//Si ha sido aceptada
				obj.rejections_days = null;
				obj.rejection_reasons_id = null;

			}if(obj.ValoresDeHistoriaClinica !== null){
				if(this.state.valoration !== 'NOT_RESULTS'){
					if(this.verifyRangesBioSV(obj)){
						this.verifyDonorDays(obj);
					}
				}else{
					this.saving(obj);
				}
			}

        }else{
            swal('Error', error, 'error');
        }
    }

    getAnswers(){
		var obj = {}, res =[];
        
		this.state.sections.forEach((cat)=>{
			cat.fields.forEach((field)=>{
                
				
				var obj = {
					Valor: field.default_value === null ? "" : field.default_value,
					IdCampo: field.field_id,
					IdFormulario: this.state.form_id
				};

				if(field.type_name === 'Fecha'){
					if(obj.Valor.length > 0){
						var aux_date = new Date(obj.Valor.split(/\//).reverse().join('/'));
						if(aux_date.toString() === 'Invalid Date'){
							swal('Formato de fecha no válido', 'PREGUNTA => "'+field.Etiqueta+'"','error');
							return null;
						}else{
							obj.Valor = aux_date;
						}
					}
				}

				res.push(obj);
			})
		})

		return res;
	}

    verifyDonorDays(obj){
        var valid = false;

		if((this.state.last_donation_date !== 'Invalid date' && this.state.last_donation_date !== 'Fecha inválida') && this.state.last_donation_date !== ""){
			var days = 0;
			var aux_date = new Date(this.state.last_donation_date);
			var today = new Date(moment(this.state.today, "DD-MM-YYYY"));
			if(this.state.person.sex === "MUJER"){
				days = 60;
			}else{
				days = 45;
			}
			var next_donation_date = this.addDays(aux_date, days);
			
			if(today < next_donation_date){
                swal({
                    title: '¡El donador tiene menos de '+days+' días de haber donado! \n ¿Desea continuar?',
                    html:true,
                    text: "",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#DD6B55',
                    confirmButtonText: '¡Si, Continuar!',
                    cancelButtonText: '¡No, Cancelar!',
                    closeOnConfirm: true,
                    closeOnCancel: true,
                }, (isConfirm)=> {
                    if (isConfirm) {
                        this.saving(obj);
                    }else{
                        return;
                    }
                });
					
			}else{
				this.saving(obj);
			}
		}else{
			this.saving(obj);
		}

	}

    async saving(obj){
        var id = '';
		var msg="";
		
		if(!this.state.update){//DAR DE ALTA POST
			msg = "Historia Clínica Guardada";
		}else{//ACTUALIZAR PUT
			id = this.state.clinic_history_id;
			msg = "Historia Clínica Actualizada";
		}

		var response = await clinicHistory(id, obj, this.props.waiting);
		if(response !== undefined){
			swal('¡Buen Trabajo!', msg,'success');
			this.setState({saved:true, clinic_history_id:this.state.update ? this.state.clinic_history_id : response.id});
		}else{
			//notify.show('Error, No se pudo guardar','error');
		}
    }

    onCancel(){
        this.props.history.goBack();
    }

    verifyRangesBioSV(obj){
		var warnings = [];
		var i, value="";

        var biometrics = this.biometrics_data.state.biometrics;
        biometrics.forEach((bio)=>{
            if(bio.ranges_validation){
                value = bio.value !== "" ? parseFloat(bio.value) : '';

                if(value !== ''){
                    if(this.state.person.sex === 'HOMBRE'){
                        if(value < bio.low_rank_male || value > bio.high_rank_male){
                            warnings.push(bio);
                        }
                    }else{
                        if(value < bio.low_rank_female || value > bio.high_rank_female){
                            warnings.push(bio);
                        }
                    }
                }
            }
        })
        var vital_signs = this.vital_signs_data.state.vital_signs;
        vital_signs.forEach((vs)=>{
            if(vs.ranges_validation){
                value = vs.value !== "" ? parseFloat(vs.value) : '';

                if(value !== ''){
                    if(this.state.person.sex === 'HOMBRE'){
                        if(value < vs.low_rank_male || value > vs.high_rank_male){
                            warnings.push(vs);
                        }
                    }else{
                        if(value < vs.low_rank_female || value > vs.high_rank_female){
                            warnings.push(vs);
                        }
                    }
                }
            }
        });

        if(warnings.length > 0){
            var msg = "<div class='biometrics-error'>";
			for(i =0;i < warnings.length;i++){
				msg+="<label >"+warnings[i].name+"</label><br/>";
				msg+="<span>Hombres => Min:"+warnings[i].low_rank_male;
				msg+=" Max: "+warnings[i].high_rank_male+"</span>";
				msg+="<span> Mujeres => Min:"+warnings[i].low_rank_female;
				msg+=" Max: "+warnings[i].high_rank_female+"</span><br/><br/>";
			}
			msg += '</div>';

			
			swal({
		        title: '¡Valores Biometría Hemática y/o Signos Vitales fuera de rango! \n ¿Desea guardar?',
		        html:true,
		        text: msg,
		        type: 'warning',
		        showCancelButton: true,
		        confirmButtonColor: '#DD6B55',
		        confirmButtonText: '¡Si, Continuar!',
		        cancelButtonText: '¡No, Cancelar!',
		        closeOnConfirm: true,
		        closeOnCancel: true,
		    }, function (isConfirm) {
		        if (isConfirm) {
		        	this.verifyDonorDays(obj);
		        	return true;
		        }else{
		        	return false;
		        }
			}.bind(this));
			
			setTimeout(()=>{
				$('.biometrics-error').parent('p').css({'height':'200px', 'overflow':'scroll'})
			}, 300)
        }else{
            return true;
        }
	}

    render(){
        const {t} = this.props;
        var id = this.props.match.params.id;

        return(
            <div className="col-xs-12">
                <BreadcrumbTitle
                    menu="Donantes"
                    page="Banco de Celulas -> Historia Clinica"
                />

                <StatusBar
                    colorStatusBar={this.state.colorStatusBar}
                    action={()=>{}}
                />

                <div className="form-hc">
                    <div className="col-xs-10 no-padding">
                        <div className="col-xs-12 no-padding">
                            <PersonData 
                                person={this.state.person}
                                patient={this.state.patient}
                                showPatient={this.state.showPatient}
                                edit={()=>{}}                            
                            />
                        </div>
                        <div className="col-xs-12 no-padding">
                            <BiometricsData 
                                {...this.props}
                                sex={this.state.person.sex}
                                exist_extraction={this.state.exist_extraction}
                                onRef={ref => this.biometrics_data = ref}
                            />
                        </div>
                        <div className="col-xs-12 no-padding">
                            <VitalSignsData  
                                {...this.props}
                                sex={this.state.person.sex}
                                exist_extraction={this.state.exist_extraction}
                                onRef={ref => this.vital_signs_data = ref}
                            />    
                        </div>                        

                        <div className="col-xs-12 form-group">
                            <div className="col-xs-12 col-sm-3 no-padding">
                                <fieldset>
                                    <legend>Fecha Última Donación</legend>
                                    <div className="col-xs-12 col-s-8">
                                        <InputForm type="date" id="last_donation_date" value={this.state.last_donation_date} handleChange={this.handleChange} />
                                    </div>
                                </fieldset>
                            </div>
                            <div className="col-xs-12 col-sm-4 no-padding">
                                <fieldset>
                                    <legend>Tiempo desde Última Donación</legend>
                                    <div className="col-xs-12 col-sm-6">
                                        <InputForm id="last_donation_time" value={this.state.last_donation_time} handleChange={this.handleChange} />
                                    </div>
                                </fieldset>
                            </div>
                            {this.state.person.sex === 'MUJER' &&
                                <div className="col-xs-12 col-sm-2">
                                    <fieldset>
                                        <legend>Gesta</legend>
                                        <div className="col-xs-12">
                                            <SelectForm 
                                                id="multigesta" 
                                                value={this.state.multigesta} 
                                                options={[{value:'1', text:'SI'},{value:'0', text:'NO'}]} 
                                                handleChange={this.handleChange} 
                                                disabled={(!this.props.task_clinic_history.create && !this.props.task_clinic_history.update)||this.state.exist_extraction}
                                                required
                                            />
                                        </div>
                                    </fieldset>
                                </div>
                            }
                        </div>
                    </div>
                    <div className="col-xs-12 col-sm-2 no-padding">
                        <AvatarInfo 
                            person={this.state.person}
                            donation_type={this.state.donation_type}
                            extraction_type={this.state.extraction_type}
                            donor_number={this.state.donor_number}
                            colorBtnHistory={this.state.colorBtnHistory}
                            openModalHistorico={this.openModalHistorico}
                        />
                    </div>
                    <div className="col-xs-12 form-group">
                        <SectionsForm 
                            {...this.props}
                            sections={this.state.sections}
                            updateForm={this.updateForm}
                        />

                        <fieldset>
	        				<legend>{t('content.modal_hc.observations')}</legend>
	        				<div className="col-xs-12">	        			
	        					<label>{this.state.staff_date}</label>
	        					<textarea className="form-control" style={{height:"250px",width:"100%",resize:"none"}}
		        					value={this.state.observations+'\n\n'+this.state.notes} disabled />

		        				{(!this.state.exist_extraction && !this.state.disable_obs) &&
		        					<textarea className="form-control-min" 
                                        value={this.state.observations} 
										style={{height:"15em",width:"100%",resize:"none"}}
										disabled={(!this.props.task_clinic_history.create && !this.props.task_clinic_history.update)||
											this.state.exist_extraction || this.state.disable_obs}
										onChange={(e)=>this.handleChange(e)} 
										name="observations" id="observations"
                                    />
	        					}
							</div>
	        			</fieldset>

                        <fieldset>
	        			    <legend>{t('content.modal_hc.conclusion')}</legend>
	        				<div className="col-xs-12 form-group conclusion">
								<div className="col-xs-12 col-md-2">
                                    <LabelForm text={t('content.modal_hc.result')} />
                                    <SelectForm 
                                        id="valoration" 
                                        value={this.state.valoration}
                                        options={[
                                            {value:'ACCEPT', text:'APTO'},
                                            {value:'PENDING', text:'PENDIENTE'},
                                            {value:'NO_APTO', text:'NO APTO'},
                                            {value:'NOT_RESULTS', text:'RECHAZADO SIN VALORAR'}
                                        ]}
                                        handleChange={this.handleChange}
                                        required
                                        disabled={(!this.props.task_clinic_history.create && !this.props.task_clinic_history.update) || this.state.exist_extraction}
                                    />
								</div>
                                {(this.state.valoration === 'NO_APTO' || this.state.valoration === 'NOT_RESULTS') &&
                                    <>
                                        <div className="col-xs-12 col-sm-6">
                                            <LabelForm text={t('content.modal_hc.rejection_reasons')} />
                                            {this.state.don_abr_rech.value === 'NO' ?
                                                <AutocompleteForm 
                                                    disabled={(!this.props.task_clinic_history.create && !this.props.task_clinic_history.update) || this.state.exist_extraction}
                                                    reference="_rejectReason"
                                                    id="reject_reason"
                                                    inputProps={{
                                                        required:this.state.don_abr_rech.value === 'NO' || this.state.valoration === 'NO_APTO' || this.state.valoration === 'NOT_RESULTS',
                                                        name:'reject_reasons_id',
                                                        id:'reject_reasons_id',
                                                        autoComplete:'off'
                                                    }}
                                                    options={this.state.rejection_reasons}
                                                    handleChange={this.onAutocompleteChange}
                                                    loading={false}
                                                    selected={this.state.index_reject !== -1 ? [this.state.rejection_reasons[this.state.index_reject]] : []}
                                                    onRef={ref => this.autocomplete_reason = ref}
                                                />
                                            :
                                                <InputForm 
                                                    id="reject_description" value={this.state.rejection_description}
                                                    handleChange={this.handleChange}
                                                    disabled={(!this.props.task_clinic_history.create && !this.props.task_clinic_history.update) || this.state.exist_extraction}
                                                    required={this.state.don_abr_rech.value === "YES" || this.state.valoration === 'NO_APTO' || this.state.valoration === 'NOT_RESULTS'}
                                                />
                                            }
                                        </div>
                                        <div className="col-xs-12 col-sm-1">
											<LabelForm text="Tipo" />
                                            <InputForm 
                                                id="donation_status" 
                                                value={this.state.donation_status === "REJECT" ? 'PERMANENTE' : this.state.donation_status === 'DIFERIDO' ? 'DIFERIDO' : ""} 
                                                handleChange={this.handleChange}
                                                disabled 
                                            />
										</div>
                                        {(this.state.donation_status === "REJECT" && this.state.rejection_type !== "") &&											
                                            <div className="col-xs-12 col-md-1">
                                                <LabelForm text={t('content.modal_hc.rejection_type')} />
                                                <InputForm 
                                                    id="rejection_type" 
                                                    value={
                                                        this.state.rejection_type === 0 ? 'PERMANENTE' :
                                                        this.state.rejection_type === 1 ? 'TEMPORAL' :
                                                        this.state.rejection_type === 2 ? 'INDEFINIDO' :
                                                        ''
                                                    }
                                                    handleChange={this.handleChange}
                                                    disabled
                                                />
                                            </div>
										}
                                        {this.state.donation_status === "DIFERIDO" &&
											<>
												<div className="col-xs-12 col-md-1">
													<LabelForm text={t('content.modal_hc.rejection_days')} />
                                                    <InputForm
                                                        id="rejection_days"
                                                        type="number"
                                                        value={this.state.rejection_days}
                                                        handleChange={this.handleChange}
                                                        disabled={ this.state.DON_EDIT_REJECT_DAYS || (this.state.DON_EDIT_REJECT_DAYS && ((!this.props.task_clinic_history.create && !this.props.task_clinic_history.update)||this.state.exist_extraction) ) }
                                                        required={this.state.donation_status === "DIFERIDO"} 
                                                    />
												</div>

												<div className="col-xs-12 col-md-2">
													<LabelForm text={t('content.modal_hc.next_donation')} />
                                                    <InputForm id="date" type="date" value={this.state.date} handleChange={this.handleChange} disabled required={this.state.donation_status} />													
												</div>
											</>										
										}
                                    </>
                                }
							</div>
	        			</fieldset>
                    </div>
                    <div className="col-xs-12 form-group">
                        <Toolbar
                            {...this.props}
                            disabled={!this.state.exist_extraction}
                            clinicHistory={true}
                            printConsent={true}
                            notes={false}
                            laboratory={false}
                            addTest={false}
                            removeIncident={false}
                            variables={{
                                clinic_history_id: this.state.clinic_history_id,
                                action_hc:'print',
                                id: id,
                                concent_key: this.state.concent_key,                                
                            }}
                            buttons={{
                                clinic_history: this.state.clinic_history_id === "",
                                concent:false,
                                notes:false,
                                lab:this.state.exist_extraction === true,
                                add_test:this.state.exist_extraction === false,
                                remove_incident:this.state.exist_extraction === false,
                            }}
                            onRef={ref => this.toolbar = ref}
                        />
                     </div>
                    <div className="col-xs-12 center">     
                        {!this.state.saved?
                            <>
                                <ButtonForm 
                                    label={t('content.generics.buttons.save')} 
                                    action={this.onSave}
                                    disabled={
                                        this.props.task_clinic_history.create ? this.state.exist_extraction  : 
                                        this.props.task_clinic_history.update ? this.state.exist_extraction ? true : false  : true
                                    }
                                />
                                <ButtonForm
                                    label={t('content.generics.buttons.reset')} 
                                    action={this.onCancel}
                                />
                            </>
                        :
                            <>
                                <ButtonForm 
                                    label={t('content.generics.buttons.finish')} 
                                    action={this.onCancel}
                                />
                            </>	
                        }   
                    </div>
                </div>
            </div>
        )
    }
}

export default translate('translations') (ClinicHistoryForm);